import { useCallback } from 'react';
import { usePermissions } from 'react-admin';
import { rolesMatch } from 'utils/user';

export function useHasRole() {
  const { permissions: roles } = usePermissions();
  return useCallback((role) => rolesMatch({ roles, role }), [roles]);
}
